<template>
  <div class="field-help">
    <a
      @click="visibleDropdown = !visibleDropdown"
      href="javascript:;" class="field-help__action-btn">
      <i class="fa fa-circle-question"></i>
    </a>
    <div class="field-help__dropdown dropdown-help" v-if="visibleDropdown">
      <div class="dropdown-help__header dropdown-help-header">
        <slot name="header"></slot>
        <button
          @click="visibleDropdown = false"
          type="button" class="close close-btn dropdown-help-header__close-btn" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="dropdown-help__body dropdown-help-body">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'HelpLabel',

  data () {
    return {
      visibleDropdown: false
    }
  }
}
</script>

<style lang="css" scoped>
</style>